<app-specific-questionnaire
  [title]="'TGA.Questionnaire.PlantingQuestions.label' | translate"
  [questions]="plantingQuestions()"
  (answersUpdated)="answersUpdated($event)"
  [readOnly]="isCropYearReadOnly()"
  [cropField]="cropField()"
  [cropYear]="cropYear()"
></app-specific-questionnaire>
